import axios from 'axios'
import { appServer } from './AppURL'

const PrivateRequest = () => {
  return axios.create({
    baseURL: appServer,
    withCredentials: true,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
}

export default PrivateRequest
